import { render, staticRenderFns } from "./PaymentsHistory.vue?vue&type=template&id=a8a52c6e&"
import script from "./PaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports